import clients from '../../../data/clients';

const client = clients.hp;

export default {
  slug: 'hp-wearable-smartwatch',
  company: client.name,
  logo: client.logo,
  logoWhite: client.logoWhite,
  blurb: {
    headline: "Launching a new class of smart watch.",
    tags: [],
    byline: 'Learn more about our work with HP',
    background: require('./preview.jpg'),
    backgroundSet: [
      {
        max: 1024,
        src: require('./preview-mobile.jpg'),
      },
    ],
  },
  blocks: [
    {
      module: 'hero',
      background: {
        image: require('./hero.jpg'),
        type: 'image',
      },
      constrain: true,
    },
    {
      module: 'intro',
      title: 'A new class of smart watch.',
      content: 'Several years ago, HP Inc. decided to enter the wearables market. Their approach was unique: HP would provide the engineering and technology; designers and watchmakers would create the watches. Each watch would look and feel like a classic analog timepiece but would have built-in intelligence and connectivity to a smartphone app.\n\nHP brought in Particle Design for help with several projects all tied to their smartwatches’ UX design.',
      roles: [
        "Roundtable Discussions",
        "1:1 Usability Testing",
        "Longitudinal Diary Study",
        "Participatory Design",
        "User Highlights Video",
      ],
    },
    {
      module: 'text_image_stack',
      image: {
        src: require('./article/1.jpg'),
        alt: 'image of watch designs',
      },
    },
    {
      module: 'text_image_row',
      images: [
        // {
        //   src: require('./article/2.jpg'),
        //   height: '540px',
        //   gravity: 'left bottom',
        // },
        {
          src: require('./article/3.jpg'),
          height: '325px',
          gravity: 'left top',
          primary: true,
        },
        {
          src: require('./article/4.jpg'),
          height: '225px',
          gravity: 'center center',
        },
      ],
      content: '## Capturing insight through real-world testing.\n\nHP also asked Particle Design to wear test two versions of a newly developed men’s smartwatch. They had the prototypes but wanted to understand the out-of-box and set-up experience. They also wanted to know which features users found helpful.\n\nParticle asked a group of potential users to wear the prototypes for ten days and maintain a diary. We helped HP streamline the information provided and steps involved with set-up. We also helped pinpoint what features were most useful and where others fell short.\n\nTo date, HP has partnered with several designers and watchmakers to create and bring to market stunning timepieces with digital capabilities, all of which incorporate insights brought to light by the Particle team.',
    },
    {
      module: 'row',
      columns: [
        {
          grid: {
            start: 2,
            end: 11,
          },
          component: 'blockquote',
          modifier: 'big',
          quote: 'About 6 months after I purchased an Apple Watch, I stopped wearing it...the beauty of the Coach Bleecker Smart Watch is that when you are wearing it, it simply looks like a nice watch with a regular analog face.',
          sourceName: 'Gear Diary, November 2016',
        },
      ],
    },
    {
      module: 'relatedWorks',
      works: [
        'dreamworks',
        'vr-science-education',
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/content/work/hp-wearable/index.js